import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { EnvironmentConfig } from './environment.interface';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentConfigService {
  private readonly environmentConfig: EnvironmentConfig = environment;

  constructor() { }

  get config(): EnvironmentConfig {
    return this.environmentConfig;
  }

  get apiUrl(): string {
    return this.environmentConfig.apiUrl;
  }

  get StripePublicKey(): string  {
    return this.environmentConfig.stripe.publicKey;
  }

  get StripeMonthlyPriceId(): string  {
    return this.environmentConfig.stripe.monthlyPriceId;
  }

  get StripeAnnualPriceId(): string  {
    return this.environmentConfig.stripe.annualPriceId;
  }

  get stripeConfig(): any {
    return this.environmentConfig.stripe;
  }

  get isProduction(): boolean {
    return this.environmentConfig.production;
  }

  get googleMapsApiKey(): string {
    return (this.environmentConfig as any).googleMapsApiKey;
  }

}
